// 区分环境
export const isDev = process.env.NODE_ENV !== 'production';

// 接口请求地址
const devURL = '/api';
const proURL = '';
export const baseURL = isDev ? devURL : proURL;

// 七牛认证（问问风湿）
const devQiNiu = {
  appid: 'tokenf1171fa0ab73709',
  appsecret: 'token8e777a9436d52dc68d9803b2f',
};
const proQiNiu = {
  appid: 'token9WHab9eLa1q1Tybf',
  appsecret: 'token50KiXfrLn1mrr1qTiPC8',
};
export const qiniuIdentity = isDev ? devQiNiu : proQiNiu;
